import { useWizardContext } from '@pages/Landings/routes/Landings/CreateLandingWizard/contexts'
import { Button, Spacer, Textarea } from '@ui-kit'
import { ChangeEvent, ChangeEventHandler } from 'react'
import { useTranslation } from 'react-i18next'
import { Column, Row } from 'simple-flexbox'

import styles from '../Eigth.module.scss'

export const PromptTextArea = ({
  setEditedPrompt
}: {
  setEditedPrompt: (value: boolean) => void
}) => {
  const { t } = useTranslation()
  const { formik, randomizeContentPrompt } = useWizardContext()
  const { values, setFieldValue } = formik

  const handleChangeContentPrompt: ChangeEventHandler<HTMLTextAreaElement> = (
    event: ChangeEvent<HTMLTextAreaElement>
  ) => {
    setFieldValue('contentPrompt', event.target.value)
    setEditedPrompt(true)
  }

  const handleChangeContentPromptWithRandomize = () => randomizeContentPrompt()

  return (
    <Column>
      <Textarea
        id='prompt-text-area'
        i18n={{
          label: t('composer.content.ai.generation.prompt.text.area.label')
        }}
        className={styles['eight-step-container__textarea']}
        value={values.contentPrompt}
        onChange={handleChangeContentPrompt}
        labelSize={14}
        isResizable={false}
      />

      <Spacer space={10} />

      <Row justifyContent='end'>
        <Button
          variant='text-primary'
          onClick={handleChangeContentPromptWithRandomize}
        >
          {t('composer.content.ai.generation.show.different.prompt.example')}
        </Button>
      </Row>
    </Column>
  )
}
